import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Header } from "semantic-ui-react";
import {
  Column,
  DataGrid,
  FormItem,
  FilterRow,
  StringLengthRule,
  RangeRule,
  RequiredRule,
  HeaderFilter,
  GroupPanel,
  Scrolling,
  Editing,
  Lookup,
  Export,
  Sorting
} from "devextreme-react/data-grid";
import { UserRoles } from "../../utils/Consts";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { authHeader } from "../../utils/AuthHeader";
import { Trans, number, t } from "@lingui/macro";
import { i18n } from "../i18n/components/ConnectProvider";
import { useRef } from "react";

export default class PrecargaOp extends Component {
  render = () => (
    <Segment padded="very" style={{ margin: 20 }}>
      <Header as="h2">
        <Trans>Precarga de Op</Trans>
        <Header.Subheader>
          <Trans>Se precargan los Op</Trans>
        </Header.Subheader>
      </Header>
      <ContractGrid />
    </Segment>
  );
}

PrecargaOp.getMenuItem = () => <Trans>Precarga Op</Trans>;
PrecargaOp.getPermissions = userLevel =>
  userLevel === UserRoles.SUPERVISOR || userLevel === UserRoles.ADMINISTRATOR;

const url = "/api/preContract";
const dataSource = createStore({
  key: "id",
  loadUrl: `${url}/get`,
  insertUrl: `${url}/post`,
  updateUrl: `${url}/put`,
  deleteUrl: `${url}/delete`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = authHeader();
  }
});

const productsSource = createStore({
  key: "code",
  loadUrl: `/api/products/get`,
  onBeforeSend: (_, ajaxOptions) => {
    ajaxOptions.headers = authHeader();
  }
});

const mapStateToProps = state => {
  return {
    user: state.authentication.user
  };
};

const ContractGrid = connect(mapStateToProps)(({ user }) => {
  const onCellPrepared = e => {
    if (e.rowType === "data") {
      const isDeleted = e.data.deleted === true;

      if (
        e.column.dataField === "__dx-gi-delete" ||
        e.column.dataField === "__dx-gi-edit" ||
        e.column.command === "edit"
      ) {
        e.cellElement.style.visibility = isDeleted ? "hidden" : "";
      }
    }
  };
  const refresh = useRef(null);

  const sortData = data => {
    // Sort the data by 'id' in descending order
    data.sort((a, b) => b.id - a.id);

    // Move deleted items to the bottom
    const deletedItems = data.filter(item => item.deleted);
    const nonDeletedItems = data.filter(item => !item.deleted);
    return [...nonDeletedItems, ...deletedItems];
  };

  function toolbarButtons(e) {
    refresh.current = e.component.refresh;
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        hint: "Refrescar datos", //Agregar traduccion
        onClick: () => e.component.refresh()
      }
    });
  }
  return (
    <DataGrid
      key={"id"}
      dataSource={dataSource}
      showBorders={true}
      style={{ maxHeight: 500, fontSize: "1rem" }}
      allowColumnReordering={true}
      allowColumnResizing={true}
      rowAlternationEnabled={true}
      onToolbarPreparing={toolbarButtons}
      remoteOperations={true}
      onCellPrepared={onCellPrepared}
      onEditorPreparing={e => {
        //Key insertAllow editNotAllow
        if (e.parentType === "dataRow" && e.dataField === "id")
          e.editorOptions.readOnly = !e.row.inserted;
      }}
      onInitialized={e => {
        // Load the data and sort it before assigning it to the grid
        dataSource.load().then(result => {
          const sortedData = sortData(result.data);
          e.component.option("dataSource", sortedData);
        });
      }}
    >
      <Sorting mode="multiple" />
      <FilterRow visible={true} />
      <HeaderFilter visible={false} />
      <GroupPanel visible={true} />
      <Scrolling mode={"infinite"} />
      <Editing
        mode={"form"}
        allowAdding={user.roleID === UserRoles.SUPERVISOR}
        allowDeleting={user.roleID === UserRoles.SUPERVISOR}
        allowUpdating={user.roleID === UserRoles.SUPERVISOR}
        useIcons={true}
      />
      <Export
        enabled
        allowExportSelectedData={false}
        fileName="OEE_ORDENES_OPERACION"
      />
      <Column
        dataField={"id"}
        caption={i18n()._(t`id`)}
        visible={false}
        calculateSortValue={rowData =>
          rowData.deleted ? Number.MAX_SAFE_INTEGER : rowData.id
        }
        defaultSortOrder="desc"
      >
        <FormItem visible={false} />
      </Column>
      <Column dataField={"op"} caption={i18n()._(t`OP`)} key>
        <RequiredRule type={"required"} />
        <StringLengthRule max={12} ignoreEmptyValue={false} />
      </Column>
      <Column dataField={"cliente"} caption={i18n()._(t`Cliente`)}>
        <StringLengthRule
          max={50}
          ignoreEmptyValue={true}
          message={i18n()._(t`Máximo 50 caracteres`)}
        />
      </Column>
      <Column dataField={"producto"} caption={i18n()._(t`Producto`)}>
        <RequiredRule
          type={"required"}
          message={i18n()._(t`El campo producto es requerido`)}
        />
        <StringLengthRule
          max={18}
          ignoreEmptyValue={true}
          message={i18n()._(t`Máximo 18 caracteres`)}
        />
        <Lookup
          dataSource={productsSource}
          valueExpr={"code"}
          displayExpr={"name"}
        />
      </Column>
      <Column
        dataField={"cosecha"}
        caption={i18n()._(t`Cosecha`)}
        dataType={"number"}
      >
        <RangeRule
          min={1000}
          max={9999}
          ignoreEmptyValue={true}
          message={i18n()._(t`El campo cosecha debe ser de 4 digitos`)}
        />
      </Column>
      <Column
        dataField={"cantidad"}
        caption={i18n()._(t`Cantidad (Toneladas)`)}
        dataType={"number"}
        format={{ type: "fixedPoint", precision: 1 }}
      >
        <RequiredRule
          type={"required"}
          message={i18n()._(t`El campo cantidad es requerido`)}
        />
      </Column>
      <Column dataField={"bolsa"} caption={i18n()._(t`Bolsa`)}>
        <StringLengthRule
          max={50}
          ignoreEmptyValue={true}
          message={i18n()._(t`Máximo 50 caracteres`)}
        />
      </Column>
      <Column
        dataField={"pesoBolsa"}
        caption={i18n()._(t`Peso bolsa (Kilogramos)`)}
        dataType={"number"}
        format={{ type: "fixedPoint", precision: 2 }}
      >
        <RequiredRule
          type={"required"}
          message={i18n()._(t`El campo peso es requerido`)}
        />
      </Column>
      <Column
        dataField={"utilizado"}
        caption={i18n()._(t`Utilizado`)}
        dataType={"boolean"}
      >
        <FormItem visible={false} />
      </Column>
      <Column dataField={"updatedBy"} caption={i18n()._(t`Actualizado por`)}>
        <FormItem visible={false} />
      </Column>
      <Column
        dataField={"updateDate"}
        dataType={"date"}
        format={"dd/MM/yyyy HH:mm:ss"}
        caption={i18n()._(t`Ultima actualización`)}
      >
        <FormItem visible={false} />
      </Column>
      <Column
        dataField={"deleted"}
        caption={i18n()._(t`Borrado`)}
        dataType={"boolean"}
        defaultSortOrder="asc"
      >
        <FormItem visible={false} />
      </Column>
    </DataGrid>
  );
});
